module.exports = __webpack_public_path__ + "static/media/9DESA18.f56b6c10.jpg";